import * as React from "react";
import "./styles.scss";
// eslint-disable-next-line @typescript-eslint/no-var-requires
const yubinbango = require("yubinbango-core2");

interface PostalCodeButtonProps {
    postalCode: string;
    handleOnClick: (address: {
        region: string;
        locality: string;
        street: string;
        extended: string;
    }) => void;
}

const PostalCodeButton = (props: PostalCodeButtonProps): JSX.Element => {
    const handleOnClick = () => {
        new yubinbango.Core(props.postalCode, function (address: {
            region: string;
            locality: string;
            street: string;
            extended: string;
        }) {
            props.handleOnClick(address);
        });
    };
    return (
        <button
            type="button"
            onClick={handleOnClick}
            className="postalCodeButton"
        >
            郵便番号から住所を入力
        </button>
    );
};

export default PostalCodeButton;
